import { render, staticRenderFns } from "./SlideMiddleSlotDialog.vue?vue&type=template&id=4b4f2d98&scoped=true&"
import script from "./SlideMiddleSlotDialog.vue?vue&type=script&lang=js&"
export * from "./SlideMiddleSlotDialog.vue?vue&type=script&lang=js&"
import style0 from "./SlideMiddleSlotDialog.vue?vue&type=style&index=0&id=4b4f2d98&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f2d98",
  null
  
)

export default component.exports